import React from "react";
import { Trophy, TrendingUp, Activity, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Profile() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return;
}